import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';
import Breadcrumb from '@/shared/components/Breadcrumb';
import Navbar from '@/shared/components/Navbar';
import Rodape from '@/shared/components/Rodape';
import MyContext from '@/shared/contexts/AppContext';
import { useSidebarCollapsed } from '@/shared/hooks/useSidebarCollapsed';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useContext, useEffect } from 'react';

function useRootBackgroundClass() {
  useEffect(() => {
    const root = document.getElementById('root');
    if (!root) return;
    root.className = 'background-ferias';
  }, []);
}

export default function AppShell() {
  const context = useContext(MyContext);
  const { collapsed, isMobile, toggle, collapse } = useSidebarCollapsed();
  const showMobileDrawer = isMobile && !collapsed;

  useRootBackgroundClass();

  useEffect(() => {
    if (!showMobileDrawer) {
      document.body.style.overflow = '';
      return;
    }
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [showMobileDrawer]);

  if (!context) {
    return (
      <>
        <Outlet />
        <ToastContainer position="top-left" pauseOnFocusLoss={false} />
      </>
    );
  }

  const { state } = context;
  const usarLayoutSidebar = Boolean(state.navbar);

  if (!usarLayoutSidebar) {
    return (
      <>
        <Navbar />
        <Breadcrumb />
        <ToastContainer position="top-left" pauseOnFocusLoss={false} />
        <div className="container container-interno overflow-auto">
          <Outlet />
        </div>
        <div className="espaco_rodape" />
        <Rodape />
      </>
    );
  }

  return (
    <div className={`app-shell${collapsed ? ' app-shell--sidebar-collapsed' : ''}`}>
      {showMobileDrawer && (
        <button
          type="button"
          className="app-shell__backdrop d-print-none"
          onClick={collapse}
          aria-label="Fechar menu"
        />
      )}
      <AppSidebar collapsed={collapsed} onToggle={toggle} onNavigate={collapse} />
      <div className="app-shell__main">
        <AppHeader sidebarCollapsed={collapsed} onMenuToggle={toggle} />
        <ToastContainer position="top-left" pauseOnFocusLoss={false} />
        <main className="app-shell__content container-interno">
          <Outlet />
        </main>
        <div className="espaco_rodape" />
        <Rodape />
      </div>
    </div>
  );
}
